var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__clip0)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.378 16.98l7.372-7.55a5.096 5.096 0 017.292 0l.08.082a5.226 5.226 0 010 7.303l-7.372 7.55a5.096 5.096 0 01-7.292 0l-.08-.083a5.226 5.226 0 010-7.302z",
    fill: "#12D2AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.048 9.43l7.292 7.467a5.344 5.344 0 010 7.467 5.096 5.096 0 01-7.292 0l-7.292-7.467a5.344 5.344 0 010-7.467 5.096 5.096 0 017.292 0z",
    fill: "#307AF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.132 9.522l3.553 3.638-7.292 7.467-7.292-7.467 3.553-3.638a5.226 5.226 0 017.478 0z",
    fill: "#0057FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3.5 7)",
    d: "M0 0h26v19H0z"
  })))));
}
export default SvgLogo;